/**
 * 里程碑挽回计划的状态（0923）。判据和后端 project-rag.ts 的 milestoneDelayFacts 同一句话：
 *   逾期 = 排了计划日期、没有实际完成日期、计划日期早于今天；
 *   有计划 = 登记了挽回日期、而且挽回日期不早于今天。
 * 项目灯：逾期没计划 = 红；逾期有计划 = 黄。改 Gate 的计划日期不算挽回。
 */
export interface RecoverableMilestone {
  id: number | string;
  milestoneCode: string;
  planDate: string | null;
  actualDate: string | null;
  recoveryDate?: string | null;
  recoveryNote?: string | null;
  recoveryByName?: string | null;
  recoveryAt?: string | null;
  recoveryCount?: number | null;
}

/**
 * none      = 没逾期、或已完成：不用说什么
 * unplanned = 逾期了、没登记挽回计划（红）
 * planned   = 逾期了、挽回日期还没过（黄）
 * expired   = 逾期了、挽回日期也过了（红：计划没兑现）
 */
export type RecoveryState = 'none' | 'unplanned' | 'planned' | 'expired';

export function shanghaiTodayText(now: Date = new Date()): string {
  return new Date(now.getTime() + 8 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

/** 逾期几天；没逾期或已完成为 0 */
export function milestoneOverdueDays(milestone: RecoverableMilestone, today: string): number {
  const plan = String(milestone.planDate ?? '').slice(0, 10);
  if (!plan || milestone.actualDate || plan >= today) return 0;
  return Math.round((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${plan}T00:00:00Z`)) / 86_400_000);
}

export function recoveryState(milestone: RecoverableMilestone, today: string): RecoveryState {
  if (!milestoneOverdueDays(milestone, today)) return 'none';
  const recovery = String(milestone.recoveryDate ?? '').slice(0, 10);
  if (!recovery) return 'unplanned';
  return recovery >= today ? 'planned' : 'expired';
}
